import React, { useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/gfDBtZ3R6C88cZLMxugwwS/WhatsApp_Image_2026-03-26_at_16.31.00.jpg',
  alt: 'Técnica de cocción y guía de legumbres'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uuHwczX7whDdUQ2P4by4qX/WhatsApp_Image_2026-03-26_at_16.30.59_(3).jpg',
  alt: 'Receta de Wrap de Falafel'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6dQgE1BzYXaP89RvPPGBzy/WhatsApp_Image_2026-03-26_at_16.30.59_(2).jpg',
  alt: 'Garbanzos Crocantes al Comino'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/orUhWiP9RzQMmEPJeVD4XP/WhatsApp_Image_2026-03-26_at_16.30.59_(1).jpg',
  alt: 'Locro Vegano de Maíz Blanco'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/b37icEn7WSSwkmKBVdRfLJ/WhatsApp_Image_2026-03-26_at_16.30.59.jpg',
  alt: 'Ensalada Tibia de Lentejas'
}];
export function BookPreviewCarousel() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  return <>
      <section className="bg-[#0a0a0a] py-6 px-4" data-id="element-31">
        <div className="max-w-5xl mx-auto" data-id="element-32">
          <div className="flex items-center gap-2 mb-4" data-id="element-33">
            <span className="text-lg" data-id="element-34">📖</span>
            <h3 className="text-sm md:text-base font-bold text-white" data-id="element-35">
              Cómo se ven por dentro nuestros libros
            </h3>
            <span className="text-zinc-500 text-xs ml-auto flex-shrink-0" data-id="element-36">
              ← deslizá →
            </span>
          </div>

          <div ref={scrollRef} className="flex gap-3 overflow-x-auto pb-3 snap-x snap-mandatory scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-37">
            {previewImages.map((img, i) => <motion.button key={i} whileTap={{
            scale: 0.97
          }} onClick={() => setSelectedImage(i)} className="flex-shrink-0 snap-start rounded-lg overflow-hidden border border-zinc-800 hover:border-emerald-600/50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500/50" data-id="element-38">
                <img src={img.src} alt={img.alt} loading="lazy" className="h-48 md:h-56 w-auto object-cover" data-id="element-39" />
              </motion.button>)}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence data-id="element-40">
        {selectedImage !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4" onClick={() => setSelectedImage(null)} data-id="element-41">
            {/* Close button */}
            <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white/70 hover:text-white text-3xl font-light z-10 w-10 h-10 flex items-center justify-center" aria-label="Cerrar" data-id="element-42">
              ✕
            </button>

            {/* Nav arrows */}
            <button onClick={e => {
          e.stopPropagation();
          setSelectedImage(selectedImage > 0 ? selectedImage - 1 : previewImages.length - 1);
        }} className="absolute left-2 md:left-6 text-white/60 hover:text-white text-2xl z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Anterior" data-id="element-43">
              ‹
            </button>
            <button onClick={e => {
          e.stopPropagation();
          setSelectedImage(selectedImage < previewImages.length - 1 ? selectedImage + 1 : 0);
        }} className="absolute right-2 md:right-6 text-white/60 hover:text-white text-2xl z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Siguiente" data-id="element-44">
              ›
            </button>

            {/* Image */}
            <motion.img key={selectedImage} initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.92
        }} transition={{
          duration: 0.2
        }} src={previewImages[selectedImage].src} alt={previewImages[selectedImage].alt} className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg" onClick={e => e.stopPropagation()} data-id="element-45" />

            {/* Counter */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-zinc-400 text-xs" data-id="element-46">
              {selectedImage + 1} / {previewImages.length}
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}